module.exports = __webpack_public_path__ + "static/media/Alámbricoift.314d749a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Alámbricoift.pdf
// module id = 62
// module chunks = 0